export default __webpack_public_path__ + "static/media/1.c2c4a2dd.svg";